import React, {useState} from "react";
import {Box, Button, TextField} from "@mui/material";
import {GameState} from "../Entity/GameStateEntity.ts";
import {sanitize} from "../Entity/KeywordEntity.ts";

interface InputsComponentProps {
	readonly gameState: GameState;
	readonly onGiveUp: () => void;
	readonly onInit: () => void;
	readonly sanitizedKeywords: string[];
	readonly onMatch: (keyword: string) => boolean;
}

export function InputsComponent(props: InputsComponentProps): React.ReactElement {
	const [inputValue, setInputValue] = useState<string>("");

	function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
		if (props.gameState === "pregame") {
			props.onInit();
		}

		const value: string = event.target.value.toLowerCase();
		setInputValue(value);

		props.sanitizedKeywords.forEach((keyword: string): void => {
			if (keyword === sanitize(value) && props.onMatch(keyword)) {
				setInputValue("");
			}
		});
	}

	return <Box sx={{
		my: 3,
		display: "flex",
		gap: 3,
		justifyContent: "center",
		alignItems: "center",
	}}>
		<TextField
			type="text"
			label="Type Keyword"
			variant="standard"
			helperText="Please keep in mind keyword data may be incomplete"
			value={inputValue}
			fullWidth
			disabled={props.gameState === "ended"}
			onChange={handleChange}
		/>
		<Button
			variant="contained"
			color="error"
			onClick={props.onGiveUp}
			disabled={props.gameState !== "running"}
			sx={{
				whiteSpace: "nowrap",
			}}>
			Give up
		</Button>
	</Box>
}
